export default "__VITE_ASSET__CHg2zReE__"